import { render, staticRenderFns } from "./baoche.vue?vue&type=template&id=b6623f06&scoped=true&"
import script from "./baoche.vue?vue&type=script&lang=js&"
export * from "./baoche.vue?vue&type=script&lang=js&"
import style0 from "./baoche.vue?vue&type=style&index=0&id=b6623f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6623f06",
  null
  
)

export default component.exports